var map = {
	"./ambassador-bg.webp": 1347,
	"./asset-2.png": 1348,
	"./btn-enter-bg.png": 1349,
	"./btn-more-bg.webp": 1350,
	"./casino-hover.webp": 1351,
	"./casino.webp": 1352,
	"./convenient.webp": 1353,
	"./es-bg.webp": 1354,
	"./event-sec-bg.webp": 1355,
	"./event-sport-bg.webp": 1356,
	"./fifa1-bg.jpg": 1357,
	"./fifa2-bg-cn.jpg": 1358,
	"./fifa2-bg.jpg": 1359,
	"./games-hover.webp": 1360,
	"./games.webp": 1361,
	"./gauge.webp": 1362,
	"./lottery-hover.webp": 1363,
	"./lottery.webp": 1364,
	"./master-bg.webp": 1365,
	"./p2p-hover.webp": 1366,
	"./p2p.webp": 1367,
	"./platform.webp": 1368,
	"./product-ctg-bg.webp": 1369,
	"./product-overview-bg.webp": 1370,
	"./professional.webp": 1371,
	"./safety.webp": 1372,
	"./slots-hover.webp": 1373,
	"./slots.webp": 1374,
	"./speed.webp": 1375,
	"./sports-hover.webp": 1376,
	"./sports.webp": 1377,
	"./video-bg.webp": 1378,
	"./wave.webp": 1379,
	"./wwr-bg.webp": 1380,
	"./wwr-img-b.webp": 1381,
	"./wwr-img.webp": 1382,
	"./wwr-subImg1.webp": 1383,
	"./wwr-subImg2.webp": 1384,
	"./wwr-subImg3.webp": 1385,
	"./x33-logo-cny.png": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;